module.exports = __webpack_public_path__ + "img/Car.bcf75458.webp";